"use strict";

import "./VehicleActivity.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import vehicleActivityStore from "./../../store/vehicleActivities";
import openedDetailsStore from "./../../store/openedDetails";
import displayedDetailsStore from "./../../store/displayedDetails";
import vehicleActivityUtils from "./../../utils/vehicleActivity";

import Card from "vwa/components/Card";
import IntervalEditor from "vwa/components/IntervalEditor";
import ProgressBar from "vwa/components/ProgressBar";
import DateTimePicker from "vwa/components/DateTimePicker";
import Toast from "vwa/components/Toast";
import Button from "vwa/components/Button";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import VehicleActivityChart from "./../VehicleActivityChart";
import VehicleActivityTimeline from "./../VehicleActivityTimeline";

import getVehicleActivity from "./../../api/getVehicleActivity";

const MAX_INTERVAL = 1000 * 60 * 60 * 24 * 31 * 6;

export default class VehicleActivity extends React.Component {

	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = {
			activityDescriptor: null,
			from: Date.parse((function(d){ d.setDate(d.getDate()-1); return d})(new Date())),
			to: Date.now(),
			inProgress: false
		};
	}
	
	setStoreListeners(){
		this.eep.on(vehicleActivityStore, "insert", activityDescriptors => this.loadActivity(activityDescriptors));
		this.eep.on(vehicleActivityStore, "update", activityDescriptor => this.loadActivity([activityDescriptor]));
		this.eep.on(displayedDetailsStore, "change", detailsDescriptor => this.handleDetailsStoreChange(detailsDescriptor));
	}
	
	shouldComponentUpdate(nextProps, nextState){
		return true; //egyelőre költségesebb getmodbyref-fel vizsgálni, mint egy újrarenderelés
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	handleDetailsStoreChange(detailsDescriptor){		
		if(detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && vehicleActivityUtils.getVisibilityOfActivity(this.props.vehicleId) && !this.state.activityDescriptor){
			this.getActivityDescriptors();
		}
	}
	
	loadActivity(activityDescriptors){
		if( activityDescriptors[0].vehicle == this.props.vehicleId &&
			activityDescriptors[0] != this.state.activityDescriptor){
			
			this.setState({
				from: activityDescriptors[0].pending ? activityDescriptors[0].from : this.state.from,
				to: activityDescriptors[0].pending ? activityDescriptors[0].to : this.state.to,
				activityDescriptor: activityDescriptors[0]
			});
		}
	}
	
	async getActivityDescriptors(){
		await getVehicleActivity(this.props.vehicleId, this.state.from, this.state.to);
		vehicleActivityUtils.focusOnVehicleActivity(this.props.vehicleId);
	}
	
	componentDidMount(){
		if(openedDetailsStore.get(this.props.vehicleId).activePage == "activity"){
			this.getActivityDescriptors();
		}
	}
	
	render(){	
		const intervalEditorProps = {
			nullable: false,
			interval: {
				from: this.state.from,
				to: this.state.to
			},
			onChange: interval => {
				if(interval.to - interval.from > MAX_INTERVAL){
					new Toast(lang.TOO_LONG_INTERVAL, "Orange");
				}
				this.setState({
					from: interval.from,
					to: interval.to
				});
			}
		}
		
		const noResult = ( this.state.activityDescriptor &&
						  !this.state.activityDescriptor.pending &&
						   this.state.activityDescriptor.sections.length == 1 &&
						   this.state.activityDescriptor.sections[0].data.length == 0);
		
		const resultClassNames = classnames("Result", {"Invisible": (this.state.activityDescriptor && this.state.activityDescriptor.pending) || !this.state.activityDescriptor || noResult});
		
		return(			
			<div className="VehicleActivity">
				<header className="Shadowed">
					<IntervalEditor {...intervalEditorProps} />
					<Button className="Red" disabled={(this.state.activityDescriptor && this.state.activityDescriptor.pending) || this.state.from && this.state.to && (this.state.to - this.state.from > MAX_INTERVAL)} onClick={_ => this.getActivityDescriptors()}>{lang.SUBMIT}</Button>
				</header>
				<div className="Content">
					<ProgressBar indeterminate shown={(this.state.activityDescriptor && this.state.activityDescriptor.pending)} />
					<h1 className={classnames("Message", {"Hidden": !noResult})} >{lang.NO_RESULTS_FOUND}</h1>
					<div className={resultClassNames}>
						<VehicleActivityChart vehicleId={this.props.vehicleId} />
						<VehicleActivityTimeline vehicleId={this.props.vehicleId} />
					</div>
				</div>
			</div>
		);
	}

}

VehicleActivity.propTypes = {
	vehicleId: React.PropTypes.string
};

VehicleActivity.defaultProps = {
	vehicleId: ""
};


// WEBPACK FOOTER //
// ./src/view/VehicleActivity/VehicleActivity.jsx